import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';

import getSymbolFromCurrency from 'currency-symbol-map';
import gtag from 'ga-gtag'

import aiRenderTeaser from '../../assets/aiRenderTeaser.mp4';
import hiUspVideo from '../../assets/hiUspVideo.mp4';
import otherUspVideo2 from '../../assets/otherUspVideo2.mp4';

// icons 
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';

import {
    getSubscriptionDetails,
} from '../../Redux/actions';

import {
    handle_activePage,
} from '../../Redux/reducer';

const Hi = () => {

    //Google Analytics Event
    gtag('event','Entered_Hi_page')

    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const user = useSelector((state) => state.auth.user);
    const subscriptions = useSelector((state) => state.auth.subscriptions);

    // console.log("lohith:Hi:subscriptions =",subscriptions);

    // useEffect(
    //     () => {
    //         dispatch(getSubscriptionDetails(user.email, "Hi"));
    //     },
    //     [1],
    // );

    function hiApp() {
        window.open("https://www.airender.co");
    }

    function checkSubscription(till_Date) {

        var parts = till_Date.split("-");
        var today = new Date();
        var endDate = new Date(parts[2] + "/" + parts[1] + "/" + parts[0]);
        // console.log("lohith:Hi:checkSubscription:endDate = ",endDate); 
        
        if (today.getTime() < endDate.getTime()) {
            // console.log("lohith:Hi:checkSubscription = today is lesser than endDate");
            return true;
        } else if (today.getTime() > endDate.getTime()) {
            // console.log("lohith:Hi:checkSubscription = today is greater than endDate");
            // should we delete the subcription record on the firebase ?
            return false;
        } else {
            // console.log("lohith:Hi:checkSubscription = today is endDate");
            return true;
        }
    }
      
    return(
        <div>
            <div className="hi-intro-section">
                <div className="hi-intro-Logo-container">
                    <div className="hi-intro-Logo active-section fade-bottom"></div>
                </div>
                <div className="hi-intro-banner-container">
                    <div className="hi-intro-banner">
                        <div className="hi-intro-banner-text">
                            Explore a new world of possibilities 
                        </div>
                        <div className="hi-intro-banner-underline"/>
                        <div className="hi-intro-banner-subtext">
                            "hi" today can support high quality video conferencing at substantially lesser bandwidth
                        </div>
                    </div>
                </div>
            </div>
            <div className='hi-usp-section'>
                <div className='hi-usp-section-title'>
                    Automatic video resolution on network bandwidth
                </div>
                <div className='hi-usp-section-main'>
                    <div className='hi-usp-description'>
                        <div className='hi-usp-description-container reveal fade-left'>
                            <div className='hi-usp-description-text'>
                                Worry no longer about network connectivity speed, hi empowers you with 4K+ video and high-fidelity audio
                            </div>
                            <div className='hi-usp-description-subtext'>
                                Don't say "NO!" to meetings just because you are in a remote location or you’ve a poor fluctuating network connectivity
                            </div>
                        </div>
                    </div>
                    <div className='hi-usp-image-container'>
                        <div className='hi-usp-image-slider reveal fade-right'>
                            <div className='hi-usp-image-slider-products'>
                                <div className='hi-usp-image-slider-hi'>
                                    <video className="hi-usp-image-slider-hi-video" autoPlay loop muted >
                                        <source src={hiUspVideo}/>
                                    </video>
                                    <div className="hi-usp-Logo"></div>
                                </div>
                                <div className='hi-usp-image-slider-other'>
                                    <video className="hi-usp-image-slider-other-video" autoPlay loop muted >
                                        <source src={otherUspVideo2}/>
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className='hi-feature-section'>
                {/* <video className="hi-feature-video" autoPlay loop muted >
                    <source src={aiRenderTeaser}/>
                </video> */}
                {/* <iframe 
                    className="hi-feature-video"
                    src="https://www.youtube.com/embed/YBjuBAaUK0E?
                    playlist=YBjuBAaUK0E
                    &loop=1
                    &autoplay=1
                    // &controls=0
                    " 
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="
                    //         accelerometer; 
                    //         autoplay; 
                    //         clipboard-write; 
                            encrypted-media; 
                    //         gyroscope; 
                    //         picture-in-picture
                    " 
                    // allowfullscreen
                >
                </iframe> */}
                <div className='hi-feature-video-container'>
                    <div className='hi-feature-video-title'>
                        {/* <i> */}
                            T<span className='hi-letter-H'>H</span>E 
                            BIG 
                            P<span className='hi-letter-I'>I</span>CTURE
                        {/* </i> */}
                    </div>
                    <video className="hi-feature-video" autoPlay loop muted >
                        <source src={aiRenderTeaser}/>
                    </video>
                </div>
                <div className='hi-feature-description'>
                    <div className='hi-feature-description-title'>
                        "Bring to Life"
                    </div>
                    <div className='hi-feature-description-content'>
                        No matter in whatever walk of life you are, 
                        wherever you are, you can visualize and 
                        experience life in the brightest of colours and 
                        the quietest and the loudest of sounds.
                    </div>
                </div>
            </div>
            <div className='hi-plans-section'>
                <div className='hi-plans-container reveal fade-bottom'>
                    <div className='price-plans'>
                        <h3 className='planName'>Basic</h3>
                        <div className='planPrice'>
                            <h1>Free</h1> 
                            <h3>/month/registration</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>More than 2 people per meeting up to 1 hour</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>2 people per meeting up to 36 hours</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>High quality video</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            {
                                isAuthenticated
                                ?   <Button className='planButton' variant="outlined" color="primary" onClick={()=>hiApp()}>Say Hi</Button>
                            	:<Link to='/contact' className='payNowButton' onClick={()=>dispatch(handle_activePage('contact'))} >
                                	<Button className='planButton' variant="outlined" color="primary">Register</Button>
                                </Link>
			    }
                        </div>
                    </div>
                    <div className='price-plans'>
                        <h3 className='planName'>Pro</h3>
                        <div className='planPrice'>
                            <h1>{getSymbolFromCurrency('INR')}400</h1> 
                            <h3>/month/subscription</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Live quality : Automatic video resolution</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>A+ AV: Best in class video quality and audio fidelity</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Seamless video conferencing even in poor network bandwidth conditions</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>A+ screen share quality</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            {subscriptions && subscriptions.Hi && subscriptions.Hi.to_date && checkSubscription(subscriptions.Hi.to_date)
                            ? <>
                                <Button className='planButton' variant="outlined" color="secondary" onClick={()=>hiApp()}>
                                    Hi Pro
                                </Button>
                                <h3 className='endDate'>Valid till {subscriptions.Hi.to_date}</h3>
                                {/* <Link to={'/payment'} 
                                    className='payNowButton' 
                                    onClick={()=>dispatch(
                                        handle_activePage('payment')
                                    )}
                                >
                                    <Button className='planButton' variant="outlined" color="secondary">
                                        Buy new
                                    </Button>
                                </Link> */}
                             </> 
                            : <Link to={isAuthenticated ? '/payment' : '/contact'} 
                                className='payNowButton' 
                                onClick={()=>dispatch(
                                    handle_activePage(isAuthenticated ? 'payment' : 'contact')
                                )}
                            >
                                <Button className='planButton' variant="outlined" color="secondary">
                                    Buy now
                                </Button>
                            </Link>}
                            
                        </div>
                    </div>
                    {/* <div className='price-plans'>
                        <h3 className='planName'>Business</h3>
                        <div className='planPrice'>
                            <h1>{getSymbolFromCurrency('INR')}1000</h1> 
                            <h3>/month/subscription</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Unlimited recording upto 24 hour</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 2</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 3</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            <Link to='/payment' className='payNowButton' onClick={()=>dispatch(handle_activePage("payment"))}>
                                <Button className='planButton' variant="outlined" color="secondary">Buy now</Button>
                            </Link>
                        </div>
                    </div>
                    <div className='price-plans'>
                        <h3 className='planName'>Hour</h3>
                        <div className='planPrice'>
                            <h1>{getSymbolFromCurrency('INR')}50</h1> 
                            <h3>/30minutes</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 1</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 2</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 3</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 4</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 5</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            <Link to='/payment' className='payNowButton' onClick={()=>dispatch(handle_activePage("payment"))}>
                                <Button className='planButton' variant="outlined" color="secondary">Try now</Button>
                            </Link>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className='disclaimer'>
                <div className='disclaimer-note1'>
                    DISCLAIMER : We don't do refund or cancelation for subscribed months, as of now.
                </div>
            </div>
        </div>
    )
}

export default Hi;
